const lockStateByElement = new WeakMap()

function defaultTargets() {
  return Array.from(new Set([
    document.scrollingElement,
    document.documentElement,
    document.body,
  ])).filter((target) => target instanceof HTMLElement)
}

function normalizeTargets(targets) {
  if (targets && Array.isArray(targets)) {
    const normalizedTargets = Array.from(new Set(targets))
      .filter((target) => target instanceof HTMLElement)

    return normalizedTargets.length > 0 ? normalizedTargets : defaultTargets()
  }

  if (targets instanceof HTMLElement) {
    return [targets]
  }

  return defaultTargets()
}

export function lockScroll(targets) {
  normalizeTargets(targets).forEach(function (element) {
    const currentState = lockStateByElement.get(element)

    if (currentState) {
      currentState.count += 1
      return
    }

    lockStateByElement.set(element, {
      count: 1,
      overflow: element.style.overflow || '',
    })

    element.style.overflow = 'hidden'
  })
}

export function unlockScroll(targets) {
  normalizeTargets(targets).forEach(function (element) {
    const currentState = lockStateByElement.get(element)
    if (!currentState) return

    currentState.count -= 1
    if (currentState.count > 0) return

    element.style.overflow = currentState.overflow
    lockStateByElement.delete(element)
  })
}
